export default __webpack_public_path__ + "static/media/amex.ffbb0e1a.svg";